import {
  USER_LOGGED_IN,
  USER_LOGGED_OUT,
  USER_SESSION_EXPIRED,
} from "../types";

export default function user(state = {}, action = {}) {
  switch (action.type) {
    case USER_LOGGED_IN: {
      return action.user;
    }
    case USER_LOGGED_OUT:
      return {};
    case USER_SESSION_EXPIRED:
      return {};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js